import { type ProgramData, type ProgramGetInput, type ProgramGetSuccess, type ProgramId } from '@terros/common'
import { useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'
import { sortProgramTasks } from './util'
import { programKey } from './keys'

export function useProgram(programId: ProgramId): GetHookResponse<ProgramData> {
  return useTantalimQuery<ProgramGetInput, ProgramGetSuccess, ProgramData>({
    url: '/program/get',
    queryKey: programKey(programId),
    input: { programId },
    convertResponse: (data) => sortProgramTasks(data.program),
  })
}
